'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _flatten2 = require('lodash/flatten');

var _flatten3 = _interopRequireDefault(_flatten2);

var _uniq2 = require('lodash/uniq');

var _uniq3 = _interopRequireDefault(_uniq2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _constants = require('../../constants');

var _util = require('../../utils/util');

var _FormattingUtils = require('../../utils/FormattingUtils');

var _FormattingUtils2 = _interopRequireDefault(_FormattingUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var EMPTY_FIELD = _constants.AppConstants.EMPTY_FIELD,
    NO_CHANGE_FIELD = _constants.AppConstants.NO_CHANGE_FIELD,
    REPRESENTATIVE_ASSIGNMENTS = _constants.AppConstants.REPRESENTATIVE_ASSIGNMENTS;
var getNameOrDefault = _FormattingUtils2.default.getNameOrDefault;
var RepresentativeDropdownAssign = (_dec = (0, _mobxReact.inject)('FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(RepresentativeDropdownAssign, _Component);

  function RepresentativeDropdownAssign() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RepresentativeDropdownAssign);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RepresentativeDropdownAssign.__proto__ || Object.getPrototypeOf(RepresentativeDropdownAssign)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isLoading', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RepresentativeDropdownAssign, [{
    key: 'onSelect',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventKey) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isLoading = true;
                _context.next = 3;
                return this.props.onChange(eventKey);

              case 3:
                this.isLoading = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSelect(_x) {
        return _ref2.apply(this, arguments);
      }

      return onSelect;
    }()
  }, {
    key: 'buildMenuItems',
    value: function buildMenuItems() {
      var _props = this.props,
          FunderStore = _props.FunderStore,
          isBulkUpdate = _props.isBulkUpdate,
          omit = _props.omit,
          selected = _props.selected,
          omitIds = Array.isArray(omit) ? omit : [omit],
          representatives = (0, _filter3.default)(FunderStore.representatives, function (rep) {
        return !omitIds.includes(rep.id);
      }),
          groups = (0, _uniq3.default)((0, _flatten3.default)(representatives.map(function (r) {
        return (0, _mobx.toJS)(r.groups);
      }))),
          menuItems = [],
          sortedGroups = (0, _util.sortArrayByArray)(groups, REPRESENTATIVE_ASSIGNMENTS);

      // No change option, used for bulk updates

      if (isBulkUpdate) {
        menuItems.push({
          eventKey: NO_CHANGE_FIELD,
          key: NO_CHANGE_FIELD,
          label: NO_CHANGE_FIELD
        });
      }

      // Unassign option, disabled if no selection
      menuItems.push({
        // Unassign is always enabled in a bulk update
        disabled: isBulkUpdate ? false : !selected,
        eventKey: null,
        key: null,
        label: 'Unassign'
      });

      sortedGroups.forEach(function (group) {
        // Group header
        menuItems.push({
          header: true,
          key: 'header_' + group,
          label: group
        });

        // Every rep in this group
        representatives.filter(function (r) {
          return r.groups.includes(group);
        }).forEach(function (representative) {
          menuItems.push({
            active: representative.id === selected,
            eventKey: representative.id,
            key: group + '_' + representative.id,
            label: getNameOrDefault(representative)
          });
        });
      });

      // Representatives with no assigned groups
      var unassigned = representatives.filter(function (r) {
        return r.groups.length === 0;
      });
      if (unassigned.length > 0) {
        menuItems.push({
          header: true,
          key: 'header_norole',
          label: 'No role'
        });
        unassigned.forEach(function (representative) {
          menuItems.push({
            active: representative.id === selected,
            eventKey: representative.id,
            key: 'norole_' + representative.id,
            label: getNameOrDefault(representative)
          });
        });
      }

      return menuItems;
    }
  }, {
    key: 'getMenuItemLabel',
    value: function getMenuItemLabel() {
      var _props2 = this.props,
          FunderStore = _props2.FunderStore,
          isBulkUpdate = _props2.isBulkUpdate,
          selected = _props2.selected,
          hasSelectedRepresentative = !!selected;


      if (!isBulkUpdate) {
        return hasSelectedRepresentative ? getNameOrDefault((0, _find3.default)(FunderStore.representatives, { id: selected })) : EMPTY_FIELD;
      }

      if (selected === null) {
        return 'Unassign';
      } else if (selected === NO_CHANGE_FIELD) {
        return NO_CHANGE_FIELD;
      }

      return getNameOrDefault((0, _find3.default)(FunderStore.representatives, { id: selected }));
    }
  }, {
    key: 'getEmptyMenuItemLabel',
    value: function getEmptyMenuItemLabel(isBulkUpdate, selected) {
      if (isBulkUpdate) {
        return 'Unassign';
      }
      return EMPTY_FIELD;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var label = this.getMenuItemLabel(),
          title = this.isLoading ? 'Loading...' : label;

      return _react2.default.createElement(
        'div',
        { className: 'dropdown-arrow right' },
        _react2.default.createElement(
          _DropdownButton2.default,
          {
            bsStyle: 'link',
            disabled: this.isLoading,
            id: 'dropdown-representative',
            pullRight: true,
            title: title
          },
          this.buildMenuItems().map(function (attr) {
            return _react2.default.createElement(
              _MenuItem2.default,
              _extends({
                key: attr.key,
                onSelect: _this2.onSelect
              }, attr),
              attr.label
            );
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RepresentativeDropdownAssign;
}(_react.Component), _class3.defaultProps = {
  isBulkUpdate: false,
  omit: null,
  onChange: _omit3.default,
  selected: null
}, _class3.propTypes = {
  FunderStore: _propTypes2.default.object.isRequired,
  isBulkUpdate: _propTypes2.default.bool,
  omit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  onChange: _propTypes2.default.func,
  selected: _propTypes2.default.string
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = RepresentativeDropdownAssign;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(EMPTY_FIELD, 'EMPTY_FIELD', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(NO_CHANGE_FIELD, 'NO_CHANGE_FIELD', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(REPRESENTATIVE_ASSIGNMENTS, 'REPRESENTATIVE_ASSIGNMENTS', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(RepresentativeDropdownAssign, 'RepresentativeDropdownAssign', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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